module.exports = __webpack_public_path__ + "img/check-icon-primary.8490e12d.svg";